module.exports = __webpack_public_path__ + "static/wood_stamped-fb291a4bbb31b68601b41c88a38c2ac8.jpeg";